import { render } from "./c-address-state.vue?vue&type=template&id=80a932ec"
import script from "./c-address-state.vue?vue&type=script&lang=js"
export * from "./c-address-state.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__